// src/models/HiddenPages.ts
export enum WidgetPage {
  VehicleInfo,
  ConfirmVehicle,
  ContactDetails,
  EngineCondition,
  BodyCondition,
  QuoteSelect,
  CustomerDetails,
  PaymentDetails,
  Confirmation
}

export interface IHiddenPage {
  id: string;
  page: WidgetPage;
  isHidden: boolean;
  defaultValuesJson: string;
  customerId: string;
}

export interface CreateHiddenPageRequest {
  page: WidgetPage;
  isHidden: boolean;
  defaultValuesJson: string;
  customerId?: string;
}

export interface UpdateHiddenPageRequest {
  page: WidgetPage;
  isHidden: boolean;
  defaultValuesJson: string;
}


//#region Widget Forms
export enum PaymentMethod {
  "Roadside"   = 0,
  "Same Day"   = 1,
  "Three Days" = 2,
}
//#endregion